import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Text } from '@tesla/design-system-react';
import styles from '../styles.module.css.js';
import { capitalizeEachWord } from '../Helpers/Utilities.js';

var DDLOption = function DDLOption(props) {
  var uid = props.uid,
    cursor = props.cursor,
    optionRef = props.optionRef,
    ignoreHover = props.ignoreHover,
    option = props.option,
    _props$header = props.header,
    header = _props$header === void 0 ? false : _props$header,
    onSelect = props.onSelect;
  var getdisplayValue = function getdisplayValue() {
    if (header) return /*#__PURE__*/React.createElement(Text, {
      is: "p",
      contrast: "low",
      className: "--tds-theme-foreground"
    }, capitalizeEachWord(option));
    var identifier = option !== null && option !== void 0 && option.value ? /*#__PURE__*/React.createElement("span", {
      className: styles['results-dropdown__item--identifier']
    }, " | ", option === null || option === void 0 ? void 0 : option.value) : '';
    return /*#__PURE__*/React.createElement(React.Fragment, null, option === null || option === void 0 ? void 0 : option.label, identifier);
  };
  return /*#__PURE__*/React.createElement("div", {
    role: "button",
    ref: (uid === null || uid === void 0 ? void 0 : uid.type) === (cursor === null || cursor === void 0 ? void 0 : cursor.type) && (uid === null || uid === void 0 ? void 0 : uid.item) === (cursor === null || cursor === void 0 ? void 0 : cursor.item) ? optionRef : null,
    key: option.label,
    tabIndex: option.label,
    className: classnames(styles.ellipses, styles['results-dropdown__item'], _defineProperty(_defineProperty(_defineProperty({}, styles['results-dropdown__item--header'], header), styles['results-dropdown__item--ignore_hover'], ignoreHover), styles['results-dropdown__item--keyboard_nav'], !header && (uid === null || uid === void 0 ? void 0 : uid.type) === (cursor === null || cursor === void 0 ? void 0 : cursor.type) && (uid === null || uid === void 0 ? void 0 : uid.item) === (cursor === null || cursor === void 0 ? void 0 : cursor.item))),
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();
      onSelect(option);
    }
  }, getdisplayValue());
};
DDLOption.defaultProps = {
  uid: '',
  cursor: {
    item: 0,
    type: 0
  },
  optionRef: function optionRef() {},
  ignoreHover: false,
  header: false,
  onSelect: function onSelect() {},
  option: {
    label: '',
    value: '',
    toUpperCase: function toUpperCase() {}
  }
};
DDLOption.propTypes = {
  uid: PropTypes.shape({
    item: PropTypes.number,
    type: PropTypes.number
  }),
  cursor: PropTypes.shape({
    item: PropTypes.number,
    type: PropTypes.number
  }),
  optionRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  ignoreHover: PropTypes.bool,
  header: PropTypes.bool,
  onSelect: PropTypes.func,
  option: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
    toUpperCase: PropTypes.func
  })
};

export { DDLOption as default };
